import { Component, ViewChild, OnInit, Output, QueryList, ViewChildren,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import {
  DanhMucs,Lists_nguonkinhphi, Lists_nhacungcap, Lists_chuong, Lists_loaikhoan, Lists_tieumuc, Lists_canbo, Lists_caphat, Lists_nghiepvu, Lists_nganhang, Lists_hoatdong, Lists_cmmt, Lists_mathongke,
  tiens_rutdutoan_ctuck, tiens_rutdutoan_ck, Lists_khachhang, Lists_taisancodinh, Lists_vattuhanghoa, Lists_congcudungcu, Lists_khohang,
  tonghops_dudauky,Lists_nhommucchi
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-ketoan-chungtuchungedit',
  templateUrl: './chungtuchungedit.component.html',


    providers: [ListService, Repository]
})


export class chungtuchungeditComponent implements OnInit {

   
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  quyen_themdoituong: boolean = false;
  quyen_themnguon: boolean = false;
  quyen_themchuong: boolean = false;
  quyen_themkhoan: boolean = false;
  quyen_themtieumuc: boolean = false;
  quyen_themcapphat: boolean = false;
  quyen_themnghiepvu: boolean = false;
  quyen_themnganhang: boolean = false;
  quyen_themctmt: boolean = false;
  quyen_themhoatdong: boolean = false;
  quyen_themthongke: boolean = false;
  quyen_themnhommuchi: boolean = false;
  quyen_themvattuhanghoa: boolean = false;
  quyen_themtaisan: boolean = false;
  quyen_themcongcu: boolean = false;
  indLoading: boolean = false;  
  //----------popup thêm đối tượng---------------------------
  @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
  @ViewChild('mdDoiTuongNH', { static: false }) mdDoiTuongNH: ModalComponent;
  @ViewChild('modalVatTu', { static: false }) modalVatTu: ModalComponent;
  @ViewChild('mdTaiSan', { static: false }) mdTaiSan: ModalComponent;
  @ViewChild('mdCongCu', { static: false }) mdCongCu: ModalComponent;
  @ViewChild('mdCanBo', { static: false }) mdCanBo: ModalComponent;
  @ViewChild('mdKhachHang', { static: false }) mdKhachhang: ModalComponent;

  @ViewChild('dtevattu', { static: false }) dtevattu: any;
  @ViewChild('dtetaisan', { static: false }) taisanedit: any;
  @ViewChild('dtecongcu', { static: false }) congcuedit: any;
  @ViewChild('dteChung', { static: false }) doituongchungedit: any;
  @ViewChild('dtenganhang', { static: false }) nganhangedit: any;
  @ViewChild('dteCanBo', { static: false }) canboedit: any;
  @ViewChild('dteKhachHang', { static: false }) khachhangedit: any;
  
  
  //------------------------------
  inputtaikhoans: any;
  inputkhachhangs: any;
  inputnguonkinhphis: any;
  inputchuongs: any;
  inputcaphats: any;
  inputnghiepvus: any;
  inputnganhangs: any;
  inputhoatdongs: any;
  inputcmmts: any;
  inputthongkes: any;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputlienquans: any;
  inputtaisans: any;
  inputhanghoas: any;
  inputhangcongcus: any;
  inputcongcus: any;
  inputkhohangs: any;
  tabselected: number = 1;
  //columns: any = [
  //  { Id: Lists_nguonkinhphi.id, Name: Lists_nguonkinhphi.text,Model:'Nguon_Id',BindValue:'Id',BindLabel:'Ten_Doi_Tuong', data: [], visible: true },
  //  { Id: Lists_loaikhoan.id, Name: Lists_loaikhoan.text, Model: 'Loai_Khoan_Id', BindValue: 'Id', BindLabel: 'Ten_Doi_Tuong', data: [], visible: true }
  //]
  columns: any = [];
  //---------------------------------
  chungtuSelect: any = {
    Id: null, Don_Vi_Id: null, Ho_Ten: null, Doi_Tuong_Id: null,
    Phan_He_Id: tonghops_dudauky.id, Dien_Giai: null, Dia_Chi: null, Ngay_Chung_Tu: null, Ngay_Ghi_So_S: null, Ngay_Chung_Tu_S: null, Ma_Chung_Tu: null, Ngay_Ghi_So: null, Hach_Toan: null, Lien_Quan_Id: null, Tai_Khoan_No_Id: '',
    SoQD: null, NgayQD: null, So_Giay_Rut_Du_Toan: null, Ngay_Giay_Rut_Du_Toan: null, Loai_Nhan_Du_Toan: null, Loai_Phan_Bo_Du_Toan: null, Nghiep_Vu_Rut_Du_Toan: null,
    CTMT_Id: null, Loai_Tien_Id: null, Tai_Khoan_Ngan_Hang1_Id: null, Tai_Khoan_Ngan_Hang2_Id: null, 
    ChiTiets: [], DongThois: []
  };

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

  @Output() save: EventEmitter<any> = new EventEmitter();
    constructor(  private repo: Repository) {
  }
  selectedTab(tab: number) {
    this.tabselected = tab;
    setTimeout(() => {
      this.setComboFocus(0, 1, tab);
    }, 500);
  }

  donviid: any;
  username: any;
  namketoan: any
  phanheid: any;

  ngOnInit(): void {
    
    //----------------------lây thông tin ban đầu

    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
      var giatri = crru.ds_quyen.filter(name => name.id === tonghops_dudauky.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
      // gán quyền thêm đối tượng
      var giatri1 = crru.ds_quyen.filter(name => name.id === ('532A61EA-D765-844B-8CBF-E610B209E332').toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themdoituong = true;
        else
          this.quyen_themdoituong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nguonkinhphi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnguon = true;
        else
          this.quyen_themnguon = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_chuong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themchuong = true;
        else
          this.quyen_themchuong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_loaikhoan.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themkhoan = true;
        else
          this.quyen_themkhoan = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_tieumuc.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtieumuc = true;
        else
          this.quyen_themtieumuc = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_caphat.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcapphat = true;
        else
          this.quyen_themcapphat = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nghiepvu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnghiepvu = true;
        else
          this.quyen_themnghiepvu = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nganhang.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnganhang = true;
        else
          this.quyen_themnganhang = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_cmmt.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themctmt = true;
        else
          this.quyen_themctmt = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_hoatdong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themhoatdong = true;
        else
          this.quyen_themhoatdong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_mathongke.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themthongke = true;
        else
          this.quyen_themthongke = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nhommucchi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnhommuchi = true;
        else
          this.quyen_themnhommuchi = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_vattuhanghoa.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themvattuhanghoa = true;
        else
          this.quyen_themvattuhanghoa = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_taisancodinh.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaisan = true;
        else
          this.quyen_themtaisan = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_congcudungcu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcongcu = true;
        else
          this.quyen_themcongcu = false;
      }



    }
    //-----------------------------------------------
    this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: this.namketoan, DonViId: this.donviid, UserName: this.username })
      .subscribe(response => {
        this.inputtaikhoans = response;
      });
    }





  public innerHeight: any;
  public chungtuid: any;
  
  public isHangHoa: number = 0;
  loadDataInit(tdonviid: any, idchungtu: any, idphanhe: any)
  {
    this.chungtuid = idchungtu;
    this.phanheid = idphanhe;
    this.innerHeight = window.innerHeight - 150;

    //Lấy thông tin của phân hệ để xem phân hệ có hiển thị cột số lượng, đơn giá hay không.
    //if (this.taikhoan.Hang_Hoa === 1)
    //  this.isHangHoa = 2;
    //else
    this.isHangHoa = 0;
    console.log('-------thông tin-----------------');
    console.log(tdonviid);
    console.log(idphanhe);
    console.log('------------------------');
   
    this.chungtuSelect = {
      Id: null, Don_Vi_Id: this.donviid, Ho_Ten: null, Doi_Tuong_Id: null,
      Phan_He_Id: tonghops_dudauky.id, Dien_Giai: null, Dia_Chi: null, Ngay_Chung_Tu: null, Ngay_Ghi_So_S: null, Ngay_Chung_Tu_S: null, Ma_Chung_Tu: null, Ngay_Ghi_So: null, Hach_Toan: null, Lien_Quan_Id: null, Tai_Khoan_No_Id: null,
      SoQD: null, NgayQD: null, So_Giay_Rut_Du_Toan: null, Ngay_Giay_Rut_Du_Toan: null, Loai_Nhan_Du_Toan: null, Loai_Phan_Bo_Du_Toan: null, Nghiep_Vu_Rut_Du_Toan: null,
      CTMT_Id: null, Loai_Tien_Id: null, Tai_Khoan_Ngan_Hang1_Id: null, Tai_Khoan_Ngan_Hang2_Id: null,
      ChiTiets: [], DongThois: []
    };


    this.repo.postRequest('api/doituong/dscottheophanhe', { id: this.phanheid})
      .subscribe(response => {
        console.log(response);
        this.columns = response;
        if (idchungtu === null || idchungtu === "null") {
          console.log('Mới');
          this.RowNewClick();
        }
        else {
          this.repo.postRequest("api/chungtu/get_thongtinchungtuv2/", { id: idchungtu, status: 0 })
            .subscribe(response => {
              console.log(response);
              this.chungtuSelect = response;            
            });
        }
      });
  
   
    setTimeout(() => {
      this.setComboFocus(0, 0, 1);
    }, 1000);
  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  RowNewClick() {
    if (this.tabselected === 3) {
      this.AddRowNew(this.chungtuSelect.DongThois);
    }
    else
      this.AddRowNew(this.chungtuSelect.ChiTiets);
  }
  AddRowNew(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Tai_Khoan_No_Id: row.Tai_Khoan_No_Id, Tai_Khoan_Co_Id: row.Tai_Khoan_Co_Id, SoCTG: row.SoCTG, NgayCTG: row.NgayCTG, Dien_Giai_Chi_Tiet: row.Dien_Giai_Chi_Tiet, So_Tien: null,
        Nguon_Id: row.Nguon_Id, Chuong_Id: row.Chuong_Id, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: row.Hinh_Thuc_Cap_Phat_Id, Nghiep_Vu_Id: row.Nghiep_Vu_Id,
        Kho_Hang_Id: row.Kho_Hang_Id, So_Duoc_Giao_Du_Toan: row.So_Duoc_Giao_Du_Toan, So_Luong: row.So_Luong, Don_Gia: row.Don_Gia, Cong_Cu_Id: row.Cong_Cu_Id, Khach_hang_Id: row.Khach_hang_Id,
        Ngan_Hang_Id: row.Ngan_Hang_Id, Ma_Thong_Ke_Id: row.Ma_Thong_Ke_Id, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: row.Hoat_Dong_Id, Hang_Hoa_Id: row.Hang_Hoa_Id, Tai_San_Id: row.Tai_San_Id, Doi_Tuong_Id: row.Doi_Tuong_Id,
        Nha_Cung_Cap_Id: row.Nha_Cung_Cap_Id, Nhan_Vien_Id: row.Nhan_Vien_Id
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Tai_Khoan_No_Id: null, Tai_Khoan_Co_Id: null, SoCTG: null, NgayCTG: null, Dien_Giai_Chi_Tiet: null, So_Tien: null, Don_Gia: null, So_Luong: null,
        Nguon_Id: null, Chuong_Id: null, Loai_Khoan_Id: null, Tieu_Muc_Id: null, Hinh_Thuc_Cap_Phat_Id: null, Nghiep_Vu_Id: null, So_Duoc_Giao_Du_Toan: null, Cong_Cu_Id: null,
        Ngan_Hang_Id: null, Ma_Thong_Ke_Id: null, CTMT_Id: null, Hoat_Dong_Id: null, Hang_Hoa_Id: null, Tai_San_Id: null, Doi_Tuong_Id: null, Kho_Hang_Id: null,
        Khach_hang_Id: null, Nha_Cung_Cap_Id: null, Nhan_Vien_Id: null
      });

    }

  }

  deleterow(index: string) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.chungtuSelect.ChiTiets.splice(index, 1);
        }
      });


  }
  maxcot: number = 2;

  keyComBoPress(event: any, hang: number, cot: number, luoi: number) {

    
    if (luoi === 1)
      this.maxcot = this.columns.length + 4 + this.isHangHoa;
    if (luoi === 3)
      this.maxcot = this.columns.length + 4 + this.isHangHoa;

    console.log('-------check enter-----------------');
    console.log(cot);
    console.log(this.maxcot);
    console.log(this.columns.length);
    console.log('------------------------');

    if (event.which === 13) {
      cot = cot + 1;

      if (cot > this.maxcot) {
        hang = hang + 1;
        cot = 1;
        if (luoi === 3) {
          if (hang === this.chungtuSelect.DongThois.length) {
            this.AddRowNew(this.chungtuSelect.DongThois);
          }
        }
        else {
          if (hang === this.chungtuSelect.ChiTiets.length) {
            this.AddRowNew(this.chungtuSelect.ChiTiets);
          }
        }

      }
      this.setComboFocus(hang, cot, luoi);
      event.preventDefault();
    }
  }
  @ViewChildren("myinput") divs: QueryList<ElementRef>;
  @ViewChildren(NgSelectComponent) slcombo: QueryList<NgSelectComponent>
  //----------event xử lý di chuyển Enter--------------------------------------
  setComboFocus(hang: number, cot: number, luoi: number) {
    var tencombo: string = hang + '_' + cot + '_' + luoi;

    if (this.isHangHoa === 2 && (cot === (this.columns.length + 1) || cot === (this.columns.length + 2))) //---------so luong, don gia
    {
      console.log(tencombo);
      var row = this.chungtuSelect.ChiTiets[hang];
      row.So_Tien = row.Don_Gia * row.So_Luong;
    }

    var ketqua = false;
    this.slcombo.forEach(
      (question, i, allQuestions) => {
        if (question.labelForId === tencombo) {
          ketqua = true;
          question.focus();
        }
      }
    );

    if (ketqua === false) {
      this.divs.forEach(
        (div) => {

          if (div.nativeElement.id === tencombo) {
            ketqua = true;
            div.nativeElement.focus();
          }

        }
      );
    }
  }
    
    public closeModal(){
        this.save.emit(null);
    }
  public savectu()
  {
    

    this.chungtuSelect.Ngay_Ghi_So_S = "01/01/1990";
    this.chungtuSelect.Ngay_Chung_Tu_S = "01/01/1990";
   

    console.log(this.chungtuSelect);
    $('#loading').show();
    this.repo.postRequest("api/chungtu/addorupdate_dauky", this.chungtuSelect)
      .subscribe(response => {
        $('#loading').hide();
        if (response.Status === "OK")
          this.save.emit(this.chungtuSelect);
        else
          swal('Cảnh báo!', response.Status, 'warning');
      }); 
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent, hang: number, cot: number) {

    this.comboSeleted = cobo;
    console.log(cobo)

    cobo.close();
    this.rowSelected = this.chungtuSelect.ChiTiets[hang];
    if (cobo.tagObject.Id.toLowerCase() === Lists_nganhang.id.toLowerCase()) {
      if (this.quyen_themnganhang == true) {
        this.nganhangedit.loadDataInit(cobo.tagObject.Id, null, this.donviid, cot);
        this.mdDoiTuongNH.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');
    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_taisancodinh.id.toLowerCase()) {
      if (this.quyen_themtaisan == true) {
        this.taisanedit.loadDataInit(cobo.tagObject.Id, null, this.donviid, cot);
        this.mdTaiSan.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');
      
    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_congcudungcu.id.toLowerCase()) {

      if (this.quyen_themcongcu == true) {
        this.congcuedit.loadDataInit(cobo.tagObject.Id, null, this.donviid, cot);
        this.mdCongCu.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');
     
    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_vattuhanghoa.id.toLowerCase()) {
      if (this.quyen_themvattuhanghoa== true) {
        this.dtevattu.loadDataInit(cobo.tagObject.Id, null, this.donviid, cot);
        this.modalVatTu.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');
    
    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_khachhang.id.toLowerCase() ||
      cobo.tagObject.Id.toLowerCase() === Lists_nhacungcap.id.toLowerCase()
    ) {
      if (this.quyen_themdoituong == true) {
        this.khachhangedit.loadDataInit(cobo.tagObject.Id, null, this.donviid, cot);
        this.mdKhachhang.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');
     
    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_canbo.id.toLowerCase() 
    ) {
      if (this.quyen_themdoituong == true) {
        this.canboedit.loadDataInit(cobo.tagObject.Id, null, this.donviid, cot);
        this.mdCanBo.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');
      
    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_chuong.id.toLowerCase()
    ) {
      if (this.quyen_themchuong == true) {
         this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
      this.mdDoiTuongChung.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');

    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_nguonkinhphi.id.toLowerCase()
    ) {
      if (this.quyen_themnguon == true) {
        this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
        this.mdDoiTuongChung.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');

    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_loaikhoan.id.toLowerCase()
    ) {
      if (this.quyen_themkhoan == true) {
        this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
        this.mdDoiTuongChung.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');

    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_cmmt.id.toLowerCase()
    ) {
      if (this.quyen_themctmt == true) {
        this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
        this.mdDoiTuongChung.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');

    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_nghiepvu.id.toLowerCase()
    ) {
      if (this.quyen_themnghiepvu == true) {
        this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
        this.mdDoiTuongChung.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');

    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_caphat.id.toLowerCase()
    ) {
      if (this.quyen_themcapphat == true) {
        this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
        this.mdDoiTuongChung.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');

    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_hoatdong.id.toLowerCase()
    ) {
      if (this.quyen_themhoatdong == true) {
        this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
        this.mdDoiTuongChung.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');

    }
    else if (cobo.tagObject.Id.toLowerCase() === Lists_mathongke.id.toLowerCase()
    ) {
      if (this.quyen_themthongke == true) {
        this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
        this.mdDoiTuongChung.open();
      }
      else
        swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');

    }
    else {
      swal('Cảnh báo!', 'Không có quyền thêm danh mục.', 'warning');
      //this.doituongchungedit.loadDataInit(cobo.tagObject.Id, null, this.donviid);
      //this.mdDoiTuongChung.open();
    }

  }
   
  //------------------------------------
  saveModalKhacHang(doituong: any) {
    this.mdKhachhang.dismiss();

    var dta = this.comboSeleted.tagObject.Data;
    dta.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong });

    this.comboSeleted.tagObject.Data = dta.slice();
    this.rowSelected[this.comboSeleted.tagObject.Model] = doituong.Id;
    
  }
  saveModalCanBo(doituong: any) {
    this.mdCanBo.dismiss();

    var dta = this.comboSeleted.tagObject.Data;
    dta.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong });

    this.comboSeleted.tagObject.Data = dta.slice();
    this.rowSelected[this.comboSeleted.tagObject.Model] = doituong.Id;
    
  }
  saveModalNganHang(doituong: any) {
    this.mdDoiTuongNH.dismiss();

    var dta = this.comboSeleted.tagObject.Data;
    dta.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong });

    this.comboSeleted.tagObject.Data = dta.slice();
    this.rowSelected[this.comboSeleted.tagObject.Model] = doituong.Id;
  }
  saveModalTaiSan(doituong: any) {
    this.mdTaiSan.dismiss();
    var dta = this.comboSeleted.tagObject.Data;
    dta.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong });

    this.comboSeleted.tagObject.Data = dta.slice();
    this.rowSelected[this.comboSeleted.tagObject.Model] = doituong.Id;
  }
  saveModalVatTu(doituong: any) {
    this.modalVatTu.dismiss();

    var dta = this.comboSeleted.tagObject.Data;
    dta.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong });

    this.comboSeleted.tagObject.Data = dta.slice();
    this.rowSelected[this.comboSeleted.tagObject.Model] = doituong.Id;
  }
  saveModal(doituong: any) {
    console.log(doituong);
    this.mdDoiTuongChung.dismiss();
    var dta = this.comboSeleted.tagObject.Data;
    dta.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong });
    
    this.comboSeleted.tagObject.Data = dta.slice();
    this.rowSelected[this.comboSeleted.tagObject.Model] = doituong.Id;
    
    this.comboSeleted.focus();
  }
   


}

